export class Controller {

    /** @ngInject */
    constructor($state, Alert, IdpAuthenticatorsService) {
        this.$state = $state;
        this.Alert = Alert;
        this.IdpAuthenticatorsService = IdpAuthenticatorsService;
    }

    $onInit() {
        this.type = 'OIDC';
    }

    save() {
        this.isSaving = true;
        this.IdpAuthenticatorsService
            .createIdpAuthenticator(this.companyId, this.name, this.type)
            .then((idpAuthenticator) => {
                this.Alert('success', 'company.idp-authenticators.add-new.added');
                return this.$state.go('^.manage', {idpAuthenticatorId: idpAuthenticator.id}, {reload: 'company.idp-authenticators'});
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/add/idp-authenticator-add.controller.js